import { sharedEnvironment } from '@raptor-fe/core';
import { MarlinEnvironment } from './marlin-environment';

export const environment: MarlinEnvironment = {
    ...sharedEnvironment,
    baseUrl: 'https://api.raptor.staging.megabus.com.au/api/',
    baseReportUrl: 'https://reports.raptor.staging.megabus.com.au/api/',
    federationApiUrl: 'https://federation.raptor.staging.megabus.com.au/api/',
    auditApiBaseUrl: 'https://audit.raptor.staging.megabus.com.au/api/',
    staffSignInEnabled: true,
    entra: {
        tenantId: '748b5735-b385-41d2-a99d-806bb5c45789',
        clientId: '020fc6ab-ea64-45e6-8b5d-30254d52036c',
        redirectUri: '',
    },
};
